import { css } from "@linaria/core";

import { sliderItemSelector } from "./item";
import { sliderTokens } from "./slider.styles";

export const item = css`
  width: calc(
    (100% - ${sliderTokens.itemMargin()} * (${sliderTokens.itemsPerPage()} - 1)) /
      ${sliderTokens.itemsPerPage()}
  );
  flex-shrink: 0;

  /* stylelint-disable-next-line */
  &:not(${sliderItemSelector.toString()}) {
    pointer-events: none;
  }
`;
